import React from 'react';
import MemberDetailsCard from './MemberDetailsCard';

const COLUMNS = [
  { field: 'BenTitle', header: 'Title' },
  { field: 'BenName', header: 'First name' },
  { field: 'BenSurname', header: 'Last name' },
  { field: 'BenDOB', header: 'Date Of Birth' },
  { field: 'BenID', header: 'ID number' },
  { field: 'BenRelation', header: 'Relationship' },
  { field: 'BenTelephone', header: 'Phone' },
  { field: 'BenGender', header: 'Gender' },
];

const ViewMemberBeneficiaries = ({ activeUserData }) => (
  <MemberDetailsCard
    title="MORE BENEFICIARY DETAILS"
    sections={[{ value: [activeUserData.memberBeneficiary], columns: COLUMNS, emptyMessage: 'No Users found' }]}
  />
);

export default ViewMemberBeneficiaries;
